import { css } from "@emotion/react";
import { appColor } from "@unit/styles";
import React from "react";

/**
 * 必須ラベルの `*`。
 *
 * ラベル文字列に `*` を混ぜると本文と同じ色になり、何が必須なのか目に入らない。
 * デモ（運営ダッシュの参照実装）は赤で出す（#1723 の l）。
 */
const RequiredMark: React.FC = () => <span css={requiredMarkStyled}>*</span>;
export default RequiredMark;

const requiredMarkStyled = css`
  color: ${appColor.App.accent};
  margin-left: 2px;
`;
